import io from 'socket.io-client';
import Logger from '../../../util/logger';
import CONFIG from '../../../config';
import Emitter from '../../../services/emitter';

const name = 'arduino';

async function process(context) {
    let socket = null;
    let options = context.options;
    if (!options) {
        options = {};
    }

    //TODO log应该由外部注入
    const log = (msg) => {
        Logger.debug(msg);
        Emitter.emit('CompilerLog', msg);
    };

    const connect = () => {
        return new Promise((resolve, reject) => {
            // console.log('connect arduino server', CONFIG, CONFIG.socket.compilerUrl);
            socket = io.connect(CONFIG.socket.compilerUrl);
            // socket连接断开
            socket.on('disconnect', () => {
                log('Arduino server disconnected.');
                reject('disconnected');
            });
            // socket连接建立
            socket.on('connect', () => {
                log('Arduino server connected.');
                resolve();
            });
            //Timeout
            setTimeout(() => {
                reject('Connect arduino server timeout');
            }, 5000);
        });

    };

    const compile = () => {
        return new Promise((resolve, reject) => {
            socket.emit('compileReq', options, context.code);
            socket.on('compileRsp', (result) => {
                log('Arduino compile finish.');
                if (result) {
                    resolve(result);
                } else {
                    reject('Arduino compile fail');
                }
            });
            log('Arduino compile...');
            socket.on('log', (content) => {
                log(content);
            });
            // TODO Timeout
            setTimeout(() => {
                resolve({ errcode: -1, errmsg: 'compile timeout' });
            }, 20000);
        });
    };

    await connect();
    let result = await compile();
    socket.disconnect(true);
    socket = null;
    context.code = result;
    return context;
}

export default { name, process };